import { WEB_SSO } from '../../../utils/urls';
import { encryptParams } from '../../../utils/index';
import { TypeRequest } from '../../../types';

export default abstract class CommonService {
  protected request: TypeRequest;
  constructor(props: { request: any }) {
    let { request } = props;
    this.request = request;
  }
  /**
   * [get mobile verification code] out-of-date
   * @param {string} mobile the mobile used to login
   * @param {number} type codeType
   * @return {Promise} send result
   */
  protected baseSendMobileCode = (params: {
    mobile: string;
    type: number;
  }): Promise<any> => {
    let { mobile, type, ...extra_params } = params;
    const data = encryptParams({ mobile, type, ...extra_params }, [
      'mobile',
      'type',
    ]);
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_SSO.MOBILE_CODE_URL,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * [get mobile verification code V2]
   * @param {string} mobile the mobile used to login
   * @param {number} type codeType
   * @return {Promise} send result
   */
  protected baseSendMobileCodeV2 = (params: {
    mobile: string;
    type: number;
  }): Promise<any> => {
    let { mobile, type, ...extra_params } = params;
    const data = encryptParams({ mobile, type, ...extra_params }, [
      'mobile',
      'type',
    ]);
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_SSO.MOBILE_CODE_URL_V2,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * [send a verification url to email] out-of-date
   * @param {string} email the email used to verify
   * @param {number} ect_type type
   * @param {string} next direct url
   * @param {string} password password
   * @return {Promise} send result
   */
  protected baseSendEmailLink = (params: {
    email: string;
    ect_type: number;
    next: string;
    password?: string;
  }): Promise<any> => {
    let { email, password, ...extra_params } = params;
    const data = encryptParams({ email, password, ...extra_params }, [
      'email',
      'password',
    ]);
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_SSO.EMAIL_ACTIVATE_URL,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * [send a verification link to email v2]
   * @param {string} email the email used to verify
   * @param {number} ect_type type
   * @param {string} next direct url
   * @param {string} password password
   * @return {Promise} send result
   */
  protected baseSendEmailLinkV2 = (params: {
    email: string;
    ect_type: number;
    next: string;
    password?: string;
  }): Promise<any> => {
    let { email, password, ...extra_params } = params;
    const data = encryptParams({ email, password, ...extra_params }, [
      'email',
      'password',
    ]);
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_SSO.EMAIL_ACTIVATE_URL_V2,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * [send a verification code to email] out-of-date
   * @param {string} email the email used to verify
   * @param {number} ect_type type
   * @param {string} next direct url
   * @param {string} password password
   * @return {Promise} send result
   */
  protected baseSendEmailCode = (params: {
    email: string;
    ect_type: number;
    next?: string;
    password?: string;
    email_logic_type?: number;
  }): Promise<any> => {
    let { email, password, ...extra_params } = params;
    const data = encryptParams({ email, password, ...extra_params }, [
      'email',
      'password',
    ]);
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_SSO.EMAIL_ACTIVATE_CODE_URL,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * [send a verification code to email v2]
   * @param {string} email the email used to verify
   * @param {number} ect_type type
   * @param {string} next direct url
   * @param {string} password password
   * @return {Promise} send result
   */
  protected baseSendEmailCodeV2 = (params: {
    email?: string;
    ect_type: number;
    next?: string;
    password?: string;
    email_logic_type?: number;
  }): Promise<any> => {
    let { email, password, ...extra_params } = params;
    const data = encryptParams({ email, password, ...extra_params }, [
      'email',
      'password',
    ]);
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_SSO.EMAIL_ACTIVATE_CODE_URL_V2,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };
}
